import { useState } from "react";
import { useEffect } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import React from "react";
import { useRef } from "react";
import Popover from "@mui/material/Popover";
import { ToastContainer, toast } from "react-toastify";
import { FaRegEdit } from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";

import { FaRoad } from "react-icons/fa";


import api from "../../services/api";
import "react-toastify/dist/ReactToastify.css";
import ChaveOn from "../../assets/chaveOn.png";
import ChaveOff from "../../assets/chaveOff.png";
import SireneOn from "../../assets/sireneOn.png";
import SireneOff from "../../assets/sireneOff.png";
import BateriaOn from "../../assets/bateria.png";
import BateriaOff from "../../assets/bateriaOff.png";
import BloqueioOn from "../../assets/cadeadoOn.png";
import BloqueioOff from "../../assets/cadeadoOff.png";
import MapaPin from "../../assets/mapaPin.png";
import Google from "../../assets/Goggle.webp";
import Pin from "../../assets/pin.png";
import "../Maps&Actions/styles.scss";
import CampoEditavel_Desc, { CampoEditavel_Obs } from "./campoeditavel";
import Tooltip from "@mui/material/Tooltip";
import { IoIosCopy } from "react-icons/io";
import Swal from "sweetalert2";
import { display, maxWidth, minWidth, positions, style, width } from "@mui/system";
import { textAlign } from "@mui/system";
import { formGroupClasses } from "@mui/material";
import { MdGpsFixed, MdGpsOff } from "react-icons/md";
import { padding } from "@mui/system";



//FUNÇÃO PARA BOTOES DENTRO DE ENDEREÇO 
function EnderecoPopover({ value, lat, lon, map, placa }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mouseStart, setMouseStart] = useState(null);
  const hoverTimer = useRef(null);

  const open = Boolean(anchorEl);

  //TEMPO DE PERMANENCIA PARA ABRIR 
  const handleOpen = (event) => {
    const target = event.currentTarget;

    hoverTimer.current = setTimeout(() => {
      setAnchorEl(target);
    }, 700); // tempo necessário parado
  };

  const handleLeave = () => {
    clearTimeout(hoverTimer.current);
  };

  //FECHAR
  const handleClose = () => {
    clearTimeout(hoverTimer.current);
    setAnchorEl(null);
  };
  //FUNÇÃO ABRIR MAPA
  const AbrirMapas = () => {
    window.open(
      `https://www.google.com/maps?q=${lat},${lon}`,
      "_blank"
    );
  };







  //FUNÇÃO PARA RELATÓRIO POSIÇÃO
  const navigate = useNavigate();
  const handleNavigateRelatorio = () => {
    window.open(
      "/posicao-relatorio",
      "_blank",
      "noopener,noreferrer"
    );
  };
  //FUNÇÃO COPIAR LAT,LON
  const handleCopyCoords = async () => {
    const coords = `${Number(lat) || 0}, ${Number(lon) || 0}`;

    try {
      await navigator.clipboard.writeText(coords);

      await Swal.fire({
        title: "Coordenadas copiadas",
        html: `
    <div style="
      margin-top:12px;
      padding:14px 16px;
      background:#F8FAFC;
      border:1px solid #E2E8F0;
      border-radius:10px;
      font-size:14px;
      color:#334155;
      font-family:Consolas, monospace;
      text-align:center;
      letter-spacing:0.5px;
    ">
      ${lat}, ${lon}
    </div>
  `,
        icon: "success",
        showConfirmButton: true,
        timer: false,
        timerProgressBar: false,
        width: "420px",
      });


    } catch (err) {
      await Swal.fire({
        icon: "error",
        title: "Falha ao copiar",
        text: "Não foi possível copiar as coordenadas.",
        confirmButtonText: "Fechar",
        confirmButtonColor: "#dc2626"
      });
    }
  };

  return (
    <>
      <div
        // ABRE O POPOVER
        onMouseEnter={handleOpen}
        onMouseLeave={handleLeave}




        style={{
          width: "100%",
          height: "auto",
          position: "relative",


          display: "-webkit-box",
          WebkitLineClamp: 3,
          WebkitBoxOrient: "vertical",

          overflow: "hidden",
          whiteSpace: "normal",
          wordBreak: "break-word",
          overflowWrap: "break-word",

          fontSize: "9.5pt",

          lineHeight: "1.3",
          paddingLeft: "10px",

          fontWeight: 500,

          cursor: "pointer",
        }}
      >
        {value}
      </div>

      <Popover

        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            border: "none",
            borderRadius: "5px",
            padding: 0,

          },
        }}
        disableScrollLock
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        disableRestoreFocus
      >
        <div
          onMouseLeave={handleClose}
          className="popover-infoGrid"


        >
          <div className="popover-texto">
            <MdLocationOn
              style={{
                color: "#0F73B2",
                fontSize: "18px",
                flexShrink: 0,
                marginTop: "2px"
              }}
            />
            <span>
              {value}
            </span>

          </div>

          <div className="popover-botoes">


            <button onClick={AbrirMapas}>
              <Tooltip title="Mostrar no Google Maps">
                <span className="mapa-icon-wrapper">
                  <img
                    src={Google}
                    alt="Abrir no Google Maps"
                    className="status-icon"
                  />
                </span>
              </Tooltip>
            </button>

            <button onClick={handleCopyCoords}>
              <Tooltip title="Copiar LAT, LONG">
                <span onClick={handleCopyCoords} className="mapa-icon-wrapper">
                  <IoIosCopy className="status-icon" />
                </span>
              </Tooltip>
            </button>

            <button onClick={handleNavigateRelatorio}>

              <Tooltip title="Relatório de Posições">
                <span className="botao-relatio-posicao">
                  <FaRoad size={20} />
                </span>
              </Tooltip>
            </button>
          </div>
        </div>
      </Popover>
    </>
  );
}







const ExampleComponent = ({ map, filteredData }) => {
  const [data, setData] = useState([]);
  const [obsValues, setObsValues] = useState({});
  const [nomeValues, setNomeValues] = useState({});
  const navigate = useNavigate();






  const zoom = 15; // Valor de zoom desejado




  const [visibleColumns, setVisibleColumns] = useState(() => {
    const saved = localStorage.getItem("visibleColumns");

    return saved
      ? JSON.parse(saved)
      : {};
  });


  // Função para atualizar a visibilidade de uma coluna
  const isColumnVisible = (columnName, defaultValue = true) => {
    return visibleColumns?.[columnName] ?? defaultValue;
  };












  const columns = [



    {
      name: "placa",
      label: "Placa",
      options: {
        filter: true,
        sort: true,

        setCellProps: () => ({
          style: {
            width: "6%",

            textAlign: "center"



          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "6%",

          },
        }),

        customBodyRender: (value) => {
          if (!value || !String(value).trim()) {
            return (
              <span
                style={{
                  color: "#999",
                  fontSize: "9.5pt",
                  fontStyle: "italic"
                }}
              >
                Sem placa
              </span>
            );
          }

          let placa = String(value).toUpperCase().trim();

          // Formata placas antigas sem hífen
          if (/^[A-Z]{3}[0-9]{4}$/.test(placa)) {
            placa = `${placa.substring(0, 3)}-${placa.substring(3)}`;
          }

          return (
            <span
              title={placa}
              style={{
                display: "block",
                textAlign: "left",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                fontSize: "9.5pt",
                fontWeight: 500,
                marginLeft: "0px",
                paddingLeft: "12px",


              }}
            >
              {placa}
            </span>
          );
        },
      },
    },



    {
      name: "nome",
      label: "Descrição",
      options: {
        filter: true,
        sort: true,

        setCellProps: () => ({
          style: {
            width: "3%",
            overflow: "hidden",
            padding: "0"


          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "3%",
            padding: "0"
          },
        }),

        customBodyRender: (value, tableMeta) => {
          // tableMeta.rowData é um ARRAY.
          // Procuramos nele o valor da coluna "equipamento".
          const equipamento = tableMeta.rowData.find(
            (_, index) => columns[index]?.name === "equipamento"
          );

          const descricao = value;

          const currentNome =
            nomeValues[equipamento] ?? descricao;

          const nomeExibido =
            !currentNome || !String(currentNome).trim()
              ? "N/A"
              : String(currentNome)
                .toLowerCase()
                .replace(/\b\w/g, (l) => l.toUpperCase());

          if (!currentNome || !String(currentNome).trim()) {
            return (
              <Tooltip
                title={
                  <>
                    <strong>Descrição</strong>
                    <br />
                    Clique para adicionar uma descrição.
                  </>
                }
                arrow
                placement="top"
              >
                <form
                  style={{
                    padding: "0",
                    overflow: "hidden",
                    fontSize: "9.5pt",
                    fontWeight: "normal",
                    textAlign: "center",
                    color: "#999",
                    fontStyle: "italic",
                  }}
                >
                  <CampoEditavel_Desc
                    campo="Descrição"
                    equipamento={equipamento}
                    currentNome={nomeExibido}
                    setNomeValues={setNomeValues}
                    id={equipamento}
                  />
                </form>
              </Tooltip>
            );
          }

          const nomeFormatado = String(currentNome)
            .toLowerCase()
            .replace(/\b\w/g, (l) => l.toUpperCase());

          return (
            <Tooltip
              title={
                <>
                  <strong>Descrição</strong>
                  <br />
                  Clique para editar ou visualizar o conteúdo.
                </>
              }
              arrow
              placement="top"
            >
              <form
                title={currentNome}
                style={{
                  overflow: "hidden",
                  fontSize: "9.5pt",
                  fontWeight: 500,
                  textAlign: "left",
                }}
              >
                <CampoEditavel_Desc
                  campo="Descrição"
                  equipamento={equipamento}
                  currentNome={nomeFormatado}
                  setNomeValues={setNomeValues}
                  id={equipamento}
                />
              </form>
            </Tooltip>
          );
        },
      },
    },

    //COLUNA MOTORISTA TABELA
    {
      name: "motora",
      label: "Motorista",
      options: {
        display: isColumnVisible("motorista_apelido", false),
        viewColumns: true,
        filter: true,
        sort: true,

        setCellProps: () => ({
          style: {
            width: "15%",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "15%",
          },
        }),

      customBodyRender: (value) => {

  const motorista = String(value || "").trim();

  // ========================================================
  // SEM MOTORISTA
  // ========================================================

  if (!motorista) {
    return (
      <span
        style={{
          color: "#999",
          textAlign: "left",
          fontSize: "9.5pt",
          fontWeight: 500,
          fontStyle: "italic",
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          whiteSpace: "normal",
          textOverflow: "ellipsis",
        }}
      >
        Motorista não logado...
      </span>
    );
  }

  // ========================================================
  // FORMATA O NOME
  // ========================================================

  const nomeFormatado = motorista
    .toLowerCase()
    .replace(/\b\w/g, (l) => l.toUpperCase());

  // ========================================================
  // MOTORISTA ENCONTRADO
  // ========================================================

  return (
    <div
      title={motorista}
      style={{
        fontWeight: 500,
        fontSize: "9.5pt",
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        whiteSpace: "normal",
        textOverflow: "ellipsis",
        width: "100%",
      }}
    >
      {nomeFormatado}
    </div>
  );
},
      },
    },





    {
      name: "obs_b",
      label: "Observação",
      options: {
        display: isColumnVisible("obs_b", false),
        viewColumns: true,
        filter: false,
        sort: false,

        setCellProps: () => ({
          style: {
            textAlign: "center",
            width: "8%",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "8%",
          },
        }),

        customBodyRender: (value, tableMeta) => {

          const equipamento = tableMeta.rowData.find(
            (_, index) => columns[index]?.name === "equipamento"
          );

          const observacao = value;

          const currentValue =
            obsValues[equipamento] ?? observacao;

          const valorExibido =
            !currentValue || !String(currentValue).trim()
              ? "N/A"
              : currentValue;

          return (
            <Tooltip
              title={
                <>
                  <strong>Observação</strong>
                  <br />
                  Clique para editar ou visualizar o conteúdo.
                </>
              }
              arrow
              placement="top"
            >
              <form
                className="d-flex gap-1"
                style={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  overflowWrap: "break-word",
                  lineHeight: "1.3",
                  maxHeight: "3.9em",
                }}
              >
                <CampoEditavel_Obs
                  equipamento={equipamento}
                  currentObs={valorExibido}
                  setObsValues={setObsValues}
                  id={equipamento}
                  campo="Observação"
                />
              </form>
            </Tooltip>
          );
        },
      },
    },

    {
      name: "posicao_em",
      label: "DT/HR",
      options: {
        display: true,
        viewColumns: true,
        filter: true,
        sort: true,

        setCellProps: () => ({
          style: {
            width: "8%",

          },
        }),

        setCellHeaderProps: () => ({
          width: "8%"

        }),

        customBodyRender: (value) => {
          if (!value) return "--";

          const data = new Date(value);

          return (
            <div
              style={{
                textAlign: "center",
                fontWeight: 500,
                fontSize: "9.5pt",
                whiteSpace: "normal",



              }}
            >

              {data.toLocaleDateString("pt-BR")} <span>|</span> {data.toLocaleTimeString("pt-BR")}
            </div>
          );
        },
      },
    },










    {
      name: "endereco",
      label: "Endereço",
      options: {
        filter: true,
        sort: false,

        setCellProps: () => ({
          style: {
            width: "18%",


            overflow: "hidden",
            paddingLeft: "0px",
          },
        }),

        setCellHeaderProps: () => ({
          width: "18%"
        }),

        customBodyRender: (value, tableMeta) => {
          if (value == null) {

            return (

              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  fontSize: "9.5pt",
                  fontStyle: "italic",
                  color: "#999",
                }}
              >
                Endereço não disponível...
              </div>

            );
          }

          return (
            <EnderecoPopover
              value={value}
              lat={tableMeta.rowData[13]}
              lon={tableMeta.rowData[14]}
              map={map}
            />
          );
        },
      },
    },

    {
      name: "status",
      label: "STATUS",
      options: {
        filter: false,
        sort: false,


        setCellProps: () => ({
          style: {
            width: "3%",


            textAlign: "center",
            verticalAlign: "middle",
            padding: "0",

          },
        }),

        setCellHeaderProps: () => ({
          style: {

            textAlign: "center",
            width: "3%"


          },
        }),

        customBodyRender: (value, tableMeta) => {
          const satelites = Number(tableMeta.rowData[7]) || 0;
          const placa = tableMeta.rowData[0];
          const descricao = tableMeta.rowData[1];
          const lat = tableMeta.rowData[13] || 0;
          const lon = tableMeta.rowData[14] || 0;
          const bateria = Number(tableMeta.rowData[15]) || 0;
          const ignicao = Number(tableMeta.rowData[16]) || 0;
          const bloqueio = Number(tableMeta.rowData[17]) || 0;
          const sirene = Number(tableMeta.rowData[18]) || 0;
          const bateriaValue = Number(bateria) || 0;
          const mostrarBateriaOff = bateriaValue <= 5;
          const mostrarSireneOn = sirene === 1;





          //FUNÇÃO MOSTRAR NO MAPA
          const handleCenter = () => {


            if (!map) return;

            const posicao = {
              lat: Number(lat),
              lng: Number(lon),
            };

            map.setCenter(posicao);

            map.setZoom(19);

            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });



            const pulse = new window.google.maps.Circle({
              map,
              center: posicao,

              radius: 2,

              strokeColor: "#0F73B2",
              strokeOpacity: 0.9,
              strokeWeight: 2,

              fillColor: "#0F73B2",
              fillOpacity: 0.05,
            });

            let raio = 2;

            const animacao = setInterval(() => {

              raio += 0.35;

              pulse.setRadius(raio);

              pulse.setOptions({
                strokeOpacity: Math.max(0, 0.9 - (raio / 18)),
                fillOpacity: Math.max(0, 0.05 - (raio / 200)),
              });

              // Reinicia o pulso
              if (raio >= 15) {

                raio = 0;

                pulse.setRadius(3);

                pulse.setOptions({
                  strokeOpacity: 0.9,
                  fillOpacity: 0.05,
                });

              }

            }, 40);

            // Mantém pulsando por 6 segundos
            setTimeout(() => {

              clearInterval(animacao);

              let fade = 1;

              const fadeOut = setInterval(() => {

                fade -= 0.05;

                pulse.setOptions({
                  strokeOpacity: fade,
                  fillOpacity: fade * 0.06,
                });

                if (fade <= 0) {

                  clearInterval(fadeOut);

                  pulse.setMap(null);


                }

              }, 50);

            }, 6000);

          };



          return (
            <div className="status-container">



              <div className="status-item">
                <Tooltip title={`Ignição: ${ignicao == 1 ? "Ligada" : "Desligada"}`}>
                  <img
                    src={ignicao == 1 ? ChaveOn : ChaveOff}
                    alt="Ignição"
                  />
                </Tooltip>
              </div>

              <div className="status-item">
                <Tooltip title={`Bloqueio: ${bloqueio == 1 ? "Ativo" : "Inativo"}`}>
                  <img
                    src={bloqueio == 1 ? BloqueioOn : BloqueioOff}
                    alt="Bloqueio"
                  />
                </Tooltip>
              </div>

              <div className="status-item">
                <Tooltip title={`Sirene: ${sirene == 1 ? "Ativa" : "Inativa"}`}>
                  <img
                    src={mostrarSireneOn ? SireneOn : SireneOff}
                    alt="Sirene"
                  />
                </Tooltip>
              </div>



              <div className="status-item">
                <Tooltip title={`Bateria: ${bateria}`}>
                  <img
                    src={mostrarBateriaOff ? BateriaOn : BateriaOff}
                    alt="Bateria"
                  />
                </Tooltip>
              </div>









              <div className="status-item">
                <Tooltip
                  title={
                    satelites < 4
                      ? `Sem sinal (${satelites} satélites)`
                      : satelites < 6
                        ? `Sinal fraco (${satelites} satélites)`
                        : `Sinal forte (${satelites} satélites)`
                  }
                >
                  <span>
                    {satelites < 4 ? (
                      <MdGpsOff
                        size={18}
                        style={{ color: "#EF4444" }}
                      />
                    ) : satelites < 6 ? (
                      <MdGpsFixed
                        size={18}
                        style={{ color: "#F59E0B" }}
                      />
                    ) : (
                      <MdGpsFixed
                        size={18}
                        style={{ color: "#22C55E" }}
                      />
                    )}
                  </span>
                </Tooltip>
              </div>



              <button onClick={handleCenter}>
                <Tooltip title="Mostrar no MAPA">
                  <span className="mapa-icon-wrapper">
                    <img
                      src={Pin}
                      alt="Mostrar no mapa"
                      className="status-icon"
                    />
                  </span>
                </Tooltip>
              </button>




              <div className="status-item">
                <button
                  onClick={() => {
                    sessionStorage.setItem(
                      "relatorio_veiculo",
                      JSON.stringify({
                        placa: placa,
                        nome: descricao,
                      })
                    );

                    window.open("/relatorio/posicao", "_blank");
                  }}
                >
                  <Tooltip title="Relatório de Posições">
                    <span className="botao-relatio-posicao">
                      <FaRoad size={18} />
                    </span>
                  </Tooltip>
                </button>
              </div>

              {/*
 <div className="status-item">
                <button
                  onClick={handleCenter}
                  className="botao-mostrarmapa"
                >
                  <Tooltip title="Mostrar no MAPA">
                    <span className="mapa-icon-wrapper">
                      <img
                        src={Pin}
                        alt="Mostrar no mapa"
                        className="status-icon"
                      />
                    </span>
                  </Tooltip>
                </button>
              </div>

              <div className="status-item">
                <button
                  onClick={AbrirMapas}
                  className="botao-mostrarmapa"
                >
                  <Tooltip title="Mostrar no Google Maps">
                    <span className="mapa-icon-wrapper">
                      <img
                        src={Google}
                        alt="Abrir no Google Maps"
                        className="status-icon"
                      />
                    </span>
                  </Tooltip>
                </button>
              </div>

              <div className="status-item">
                <Tooltip title="Relatório de Posições">
                  <button onClick={handleCopyCoords}>
                    <IoIosCopy className="botao-copiar-l_g" />
                  </button>
                </Tooltip>
              </div>




              <div className="status-item">
                <Tooltip title="Copiar LAT, LONG">
                  <span onClick={handleCopyCoords}>
                    <IoIosCopy className="botao-copiar-l_g" />
                  </span>
                </Tooltip>
              </div> */}



            </div>
          );
        },
      },
    },




    {
      name: "satelites",
      label: "Satélite",



      options: {
        display: "excluded",
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          if (value == null) return (<div style={{ textAlign: "center" }}>
            {"-"}

          </div>);

          return (
            <div style={{ textAlign: "center" }}>
              {value}
            </div>
          );
        },
      },
    },



    {
      name: "horimetro",
      label: "Horímetro",
      options: {
        filter: true,
        sort: false,
        display: isColumnVisible("horimetro", true),

        setCellProps: () => ({
          style: {
            textAlign: "center",
            width: "6%",

          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "6%",


          },
        }),

        customBodyRender: (value, tableMeta) => {
          const horimetro = Number(value) || 0;

          const equipamento = tableMeta.rowData.find(
            (_, index) => columns[index]?.name === "equipamento"
          );

          const veiculo = filteredData?.find(
            (item) => String(item.equipamento) === String(equipamento)
          );

          const modelo = String(veiculo?.modelo || "").trim().toUpperCase();



          const deveDividirDuasVezes =
            modelo === "MXT-130" ||
            modelo === "MXT-160" ||
            modelo === "MXT-162";

          const horas = deveDividirDuasVezes
            ? horimetro /60 /60
            : horimetro /60;

          return (
            <div
              style={{
                textAlign: "center",
                whiteSpace: "nowrap",
                fontSize: "9.5pt",
                fontWeight: 500,
              }}
            >
              {horas.toLocaleString("pt-BR", {
                minimumFractionDigits: 1,
                maximumFractionDigits: 1,
              })}{" "}
              h
            </div>
          );
        },
      },
    },









    {
      name: "hodometro",
      label: " ODO",
      options: {
        filter: true,
        sort: false,
        display: isColumnVisible("hodometro", true),
        viewColumns: true,

        setCellProps: () => ({
          style: {
            width: "6%",




          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "6%",

          },
        }),

        customBodyRender: (value, tableMeta) => {


          if (value == null) {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "50px",
                  fontSize: "9.5pt",
                  fontStyle: "italic",
                  color: "#999",
                }}
              >
                N/A
              </div>
            );
          }

          const km = (value / 1000).toLocaleString("pt-BR", {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          });

          return (
            <div style={{
              textAlign: "center", fontSize: "9.5pt", fontWeight: 500,

            }}>
              {`${km} Km`}
            </div>
          );
        },
      },
    },




    {
      name: "velocidade",
      label: "Vel",
      options: {
        filter: true,
        sort: false,

        setCellProps: () => ({
          style: {
            width: "4%",

            textAlign: "center",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "4%",

            textAlign: "center",
          },
        }),

        customBodyRender: (value) => {
          if (value == null) {
            return (
              <div style={{ textAlign: "center" }}>
                -
              </div>
            );
          }

          return (
            <div style={{ textAlign: "center", fontSize: "9.5pt", fontWeight: 500, }}>
              {value}km/h
            </div>
          );
        },
      },
    },


    {
      name: "temperatura",
      label: "Temp",
      options: {
        filter: true,
        sort: false,
        display: isColumnVisible("temperatura", false),
        viewColumns: true,

        setCellProps: () => ({
          style: {
            width: "4%",

            textAlign: "center",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "4%",

            textAlign: "center",
          },
        }),

        customBodyRender: (value) => {
          if (value == null) {
            return (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "9.5pt",
                  fontStyle: "italic",
                  color: "#999",
                }}
              >
                N/A
              </div>
            );
          }

          return (
            <div
              style={{
                textAlign: "center",
                fontSize: "9.5pt",
                fontWeight: 500,
              }}
            >
              {value}°C
            </div>
          );
        },
      },
    },








    {
      name: "equipamento",
      label: "Equipamento",
      options: {

        viewColumns: true,
        display: "excluded",
        filter: true,
        sort: false,
        customBodyRender: (value) => {
          if (value == null)
            return (
              <div style={{ textAlign: "center" }} className="div-texto_centro">
                {"-"}

              </div>
            )

          return (
            <div className="div-texto_centro">
              {value}

            </div>
          )
        }
      },
    },




    {
      name: "lat",
      label: "LAT | LONG",
      options: {
        viewColumns: false,
        display: "excluded",
        filter: false,
        sort: false,

        customBodyRender: (value) => {
          return `${value}`;
        },
      },
    },


    {
      name: "lon",
      label: "LONG",
      options: {
        viewColumns: false,
        display: "excluded",
        filter: false,
        sort: false,

        customBodyRender: (value) => {
          return `${value}`;
        },
      },
    },

    {
      name: "bateria",
      label: "bateria",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },

    {
      name: "ignicao",
      label: "ignicao",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },

    {
      name: "bloqueio",
      label: "bloqueio",
      options: {
        filter: false,
        sort: false,
        display: "excluded",
      },
    },
    {

      name: "sirene",
      label: "sirene",
      options: {
        filter: false,

        sort: false,
        display: "excluded",


        customBodyRender: (value, tableMeta) => {



          return `sirene: ${value == 1 ? "Ativa" : "Inativa"}`;
        }
      },

    },

    // =========================================================
    // DADOS DA REDE CAN
    // =========================================================

   {
  name: "can_rpm",
  label: "RPM",
  options: {
    display: isColumnVisible("rpm_can", false),
    viewColumns: true,
    filter: true,
    sort: true,

    setCellProps: () => ({
      style: {
        width: "6%",
        textAlign: "center",
      },
    }),

    setCellHeaderProps: () => ({
      style: {
        width: "6%",
        textAlign: "center",
      },
    }),

    customBodyRender: (value) => {
      if (value == null || value === "") {
        return (
          <div
            style={{
              textAlign: "center",
              fontSize: "9.5pt",
              fontStyle: "italic",
              color: "#999",
            }}
          >
            N/A
          </div>
        );
      }

      return (
        <div
          style={{
            textAlign: "center",
            fontSize: "9.5pt",
            fontWeight: 500,
          }}
        >
          {Number(value).toLocaleString("pt-BR")}
        </div>
      );
    },
  },
},

    {
      name: "can_temperatura_motor",
      label: "Temperatura Motor",
      options: {
        display: isColumnVisible("temperatura_motor_can", false),
        viewColumns: true,
        filter: true,
        sort: true,

        setCellProps: () => ({
          style: {
            width: "8%",
            textAlign: "center",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "8%",
            textAlign: "center",
          },
        }),

        customBodyRender: (value) => {
          if (value == null || value === "") {
            return (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "9.5pt",
                  fontStyle: "italic",
                  color: "#999",
                }}
              >
                N/A
              </div>
            );
          }

          return (
            <div
              style={{
                textAlign: "center",
                fontSize: "9.5pt",
                fontWeight: 500,
              }}
            >
              {value}°C
            </div>
          );
        },
      },
    },

    {
      name: "can_nivel_tanque",
      label: "Nível Tanque",
      options: {
        display: isColumnVisible("nivel_tanque_can", false),
        viewColumns: true,
        filter: true,
        sort: true,

        setCellProps: () => ({
          style: {
            width: "8%",
            textAlign: "center",
          },
        }),

        setCellHeaderProps: () => ({
          style: {
            width: "8%",
            textAlign: "center",
          },
        }),

        customBodyRender: (value) => {
          if (value == null || value === "") {
            return (
              <div
                style={{
                  textAlign: "center",
                  fontSize: "9.5pt",
                  fontStyle: "italic",
                  color: "#999",
                }}
              >
                N/A
              </div>
            );
          }

          return (
            <div
              style={{
                textAlign: "center",
                fontSize: "9.5pt",
                fontWeight: 500,
              }}
            >
              {String(value).replace(/L\s*/i, "").trim() + " L"}
            </div>
          );
        },
      },
    },









  ];






  const handleSave = (equipamentoId) => {
    const obsValue = obsValues[equipamentoId];

    if (!obsValue || obsValue.trim() === "") {
      toast.error("Observação está vazia.");
      return;
    }

    const id = parseInt(equipamentoId);

    if (isNaN(id)) {
      toast.error("ID do equipamento inválido");
      return;
    }

    console.log("Salvar observação para equipamento:", id, "com:", obsValue);

  };











  // LÓGICA DO BOTAO COLUNA 2 TABELA PRINCIPAL

  const handleEditar_coluna_2 = (equipamentoId) => {
    const nome = nome[equipamentoId];


    if (!nome || nome.trim() === "") {
      toast.error("Nome está vazio.");
      return;
    }

    const id = parseInt(equipamentoId);

    if (isNaN(id)) {
      toast.error("ID do equipamento inválido");
      return;
    }
  };


  return { columns };
};

export default ExampleComponent;
